import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './WebsiteLayout.css';

const WebsiteLayout = () => {
  return (
    <div className="website-layout">
      <Header />
      <main className="website-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default WebsiteLayout;
